import { render, staticRenderFns } from "./CreateControlDrug.vue?vue&type=template&id=49ee4be4&scoped=true"
import script from "./CreateControlDrug.vue?vue&type=script&lang=js"
export * from "./CreateControlDrug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ee4be4",
  null
  
)

export default component.exports